module.exports = __webpack_public_path__ + "intercom.svg?9551e977730d61d5477132e5f756c0c3";